import Swal from 'sweetalert2';

function Confirm(text) {
  this.text = text
}

Confirm.prototype.show = function (config = {}) {
  return Swal.fire({
    animation: false,
    customClass: {
      confirmButton: 'btn btn-primary mr-2',
      cancelButton: 'btn btn-outline-primary',
    },
    showConfirmButton: true,
    showCancelButton: true,
    text: this.text,
    buttonsStyling: false,
    ...config
  }).then(result => {
    return result.value;
  })
}

export default Confirm
